import { render } from "./Pemungutan.vue?vue&type=template&id=61aa832a"
import script from "./Pemungutan.vue?vue&type=script&lang=js"
export * from "./Pemungutan.vue?vue&type=script&lang=js"

import "./Pemungutan.vue?vue&type=style&index=0&id=61aa832a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__